import React from "react";
import { withWidth } from "@material-ui/core";

function InitialWidget() {
    return (
        <React.Fragment/>
    );

}

export default withWidth()(InitialWidget);

